import React from 'react';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { ButtonExtendedProps } from 'grommet';
import { useFacebookAuthResponse } from './facebook';
import { strogging } from '@shd/jslib/infra';
import { AppHostContext } from '../services/appHost';
import SHDText from '@ui/Text/SHDText';
import SHDButton from '@ui/Button/SHDButton';
import SHDThemeOverride from '@ui/ThemeOverride/SHDThemeOverride';
import { LiveStreamSettingsModal } from './LiveStreamSettingsModal';
import { analytics } from '@services/analytics';

interface Props {
  onLinkFacebookClick: () => void;
  onCloseIntroModal: () => void;
  setShowLinkingModal: (show: boolean) => void;
  fbScopes: string;
  responseFacebook: (res: undefined) => Promise<void>;
  setShowHowToSetUpModal: () => void;
  teamId: string | undefined;
}

export const FacebookSettingsModalV2: React.FC<Props> = ({
  onLinkFacebookClick,
  onCloseIntroModal,
  setShowLinkingModal,
  fbScopes,
  responseFacebook,
  setShowHowToSetUpModal,
  teamId,
}) => {
  const appHost = React.useContext(AppHostContext);
  const isHosted = appHost.isHosted;
  const authResponse = useFacebookAuthResponse();

  const handleLogin = async () => {
    analytics.track('Destination Path Choice Selected', {
      pathSelected: 'Yes',
      destinationType: 'Facebook',
      teamId,
    });
    if (authResponse) {
      onLinkFacebookClick();
      setShowLinkingModal(true);
    } else if (appHost.isHosted) {
      try {
        const response = await appHost.service.requests.authenticateFacebook();
        if (response?.accessToken) {
          onLinkFacebookClick();
          setShowLinkingModal(true);
        } else {
          strogging.error(
            'Failed to authenticate Facebook in hosted environment'
          );
        }
      } catch (error) {
        strogging.error('Error during hosted Facebook authentication', error);
      }
    }
  };

  const handleFacebookLogin = (renderProps: {
    onClick: ButtonExtendedProps['onClick'];
  }) => (
    <SHDButton
      secondary
      label={
        <SHDText size="button" style="subhead-bold" textAlign="center">
          Yes, I have live stream set up
        </SHDText>
      }
      onClick={
        renderProps.onClick as (e: React.MouseEvent<HTMLElement>) => void
      }
    />
  );

  return (
    <SHDThemeOverride>
      <LiveStreamSettingsModal
        headerText="LINK FACEBOOK"
        title="Have you ever livestreamed on Facebook?"
        onCloseModal={onCloseIntroModal}
      >
        {authResponse || isHosted ? (
          <SHDButton
            secondary
            label="Yes, I have live stream set up"
            onClick={handleLogin}
          />
        ) : (
          <FacebookLogin
            disableMobileRedirect
            version="15.0"
            appId={import.meta.env.VITE_APP_FACEBOOK_APP_ID}
            fields="name,email,picture,link"
            scope={fbScopes}
            callback={responseFacebook}
            render={handleFacebookLogin}
          />
        )}
        <SHDButton
          secondary
          label="No, I need help setting up"
          onClick={setShowHowToSetUpModal}
        />
      </LiveStreamSettingsModal>
    </SHDThemeOverride>
  );
};
